// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

const isLastEdit = objectOf({
  time: number,
  name: string,
});

export const isGetDataTableDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      campaign_name: string,
      enabled: boolean,
      is_archived: boolean,
      is_draft: boolean,
      components: arrayOf(string),
      variants_count: number,
      last_edit: isLastEdit,
    })
  ),
});
